export const getSunset = () => {
  return 'November 1';
};